import { InfoTag } from '@plato/ui-legacy/components/ui/info-tag';
import Text from '@plato/ui-legacy/components/ui/text';
import { formatShortDate } from '@plato/ui-legacy/lib/date-helpers';
import { useResolvedLocale } from '@plato/ui-legacy/lib/hooks/locale';
import { CalendarIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import type { CrmTaskDTO } from '../../../server/dto/crm-task-dto.ts';
import { getDueDateColor } from '../../../utils/task-helpers.ts';

export function OpenTaskTimelineHeader({ task }: { task: CrmTaskDTO }) {
    const { t } = useTranslation();
    const locale = useResolvedLocale();

    const color = task.status === 'COMPLETED' ? 'neutral-600' : getDueDateColor(task);

    return (
        <div className="flex w-full flex-col justify-between gap-1 sm:flex-row">
            <Text>
                <Text>{t('task')}</Text>{' '}
                <Text color="neutral-500">
                    {t('assigned_to_user', {
                        user: task.assignedTo.fullName,
                    })}
                </Text>
            </Text>
            {task.dueDate && (
                <div className="flex items-center gap-2">
                    <InfoTag icon={CalendarIcon} color={color}>
                        {formatShortDate(task.dueDate, locale)}
                    </InfoTag>
                </div>
            )}
        </div>
    );
}
